import { useTranslation } from "react-i18next"
import { WheelHouseWrapper } from "./styles"
import WellHouseIcon from "@assets/svg/well_house.svg?react"
import Input from "@Common/input"
import CustomButton from "@Common/CustomButton"
import { FormProvider, useForm } from "react-hook-form"
import { useContext, useEffect } from "react"
import dayjs from "dayjs"
import {
	APIS_KEYS,
	usePutUpdatePriceCalenderBasedOnWheelhousePrice,
} from "@services"
import { ToastMessageContext } from "@context/toast-message-cotnext"
import { loaderState, PopupOverlayNewCalender } from "@store/index"
import { useSetRecoilState } from "recoil"
import { useQueryClient } from "@tanstack/react-query"

interface IForm {
	propertyIds: string[]
	date_from: string | dayjs.Dayjs
	date_to: string | dayjs.Dayjs
	priceWheelHouse: string
}
interface IProps extends IForm {}
export default function WheelHouse({
	date_from,
	date_to,
	propertyIds,
	priceWheelHouse,
}: IProps) {
	/* ----------------------------- State Mangement ---------------------------- */
	const setPopupOverlayNewCalender = useSetRecoilState(PopupOverlayNewCalender)
	const setLoaderState = useSetRecoilState(loaderState)
	const { showSuccess } = useContext(ToastMessageContext)
	/* ---------------------------------- API'S --------------------------------- */
	const { mutateAsync } = usePutUpdatePriceCalenderBasedOnWheelhousePrice()
	const queryClient = useQueryClient()
	/* ---------------------------------- Hooks --------------------------------- */
	const { t } = useTranslation()
	const methods = useForm<IForm>({
		defaultValues: {
			date_from: "",
			date_to: "",
			propertyIds: [],
			priceWheelHouse: "",
		},
	})
	const { setValue, reset } = methods
	/* -------------------------------- Functions ------------------------------- */
	const onSubmit = async (data: IForm) => {
		setLoaderState(true)
		const { priceWheelHouse, ...restData } = data
		const response = await mutateAsync(restData)
		if (response.status === 200) {
			reset()
			setLoaderState(false)
			setPopupOverlayNewCalender(undefined)
			queryClient.invalidateQueries({ queryKey: [APIS_KEYS.GETCALENDERDATA] })
			showSuccess(t("CALENDAR.PRICE_UPDATE_SUCCESS"))
		}
		setLoaderState(false)
	}
	/* --------------------------------- Effect --------------------------------- */
	useEffect(() => {
		setValue("date_from", dayjs(date_from).format("YYYY-MM-DD"))
		setValue("date_to", dayjs(date_to).format("YYYY-MM-DD"))
		setValue("propertyIds", propertyIds)
		setValue("priceWheelHouse", priceWheelHouse)
	}, [date_from, date_to, propertyIds])
	return (
		<WheelHouseWrapper>
			<FormProvider {...methods}>
				<form onSubmit={methods.handleSubmit(onSubmit)} id='wheelHouseForm'>
					<div className='containerHeaderWellHouse'>
						<span>
							<WellHouseIcon />
						</span>
						<span>{t("CALENDAR.wellhouse_recommendations")}</span>
					</div>
					<div>
						<Input name='priceWheelHouse' label='' disabled />
					</div>
					<p>{t("CALENDAR.the_price_will_be_applied_when_you_press_save")}</p>

					<CustomButton
						label={t("CALENDAR.apply")}
						withBG
						customPadding='7px 21px'
						form='wheelHouseForm'
						type='submit'
					/>
				</form>
			</FormProvider>
		</WheelHouseWrapper>
	)
}
